import { useMutation } from "@tanstack/react-query";
import axios from "axios";

const createFolder = async (data) => {
  const { projectId, name, displayName } = data;
  try {
    const response = await axios.post(
      `/api/create-folder/${projectId}/`,
      { name, displayName },
      { withCredentials: true },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to create folder");
  }
};

export const useCreateFolder = (
  queryClient,
  projectId,
  userType,
  enqueueSnackbar,
  setOpen,
) => {
  return useMutation({
    mutationFn: createFolder,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["all-project-structure", projectId, userType],
      });
      enqueueSnackbar("Folder created successfully", { variant: "success" });
      setOpen(false);
    },
    onError: (err) => {
      console.error("CREATE FOLDER ERROR", err);
      enqueueSnackbar("Error creating folder", { variant: "error" });
    },
  });
};
